import React from 'react';

import styles from './styles.module.scss'
import { Spin } from 'antd';

const Loading = () => {
    return (
        <div className={styles.loadingWrapper}>
            <Spin size="large" />
        </div>
    )
}

export default Loading
